/*!
 * Determine if an element is in the viewport
 * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}    elem The element
 * @return {Boolean}      Returns true if element is in the viewport
 */
const isInView = (elem) => {
  const distance = elem.getBoundingClientRect()
  return (
    distance.top >= distance.height * -1 &&
    distance.left >= distance.width * -1 &&
    distance.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) +
        distance.height &&
    distance.right <=
      (window.innerWidth || document.documentElement.clientWidth) +
        distance.width
  )
}

export default isInView
